import Masonry from "react-masonry-css";

const breakpointColumns = {
  default: 3,
  1100: 3,
  768: 2,
  500: 1,
};

const images = [
  {
    src: "assets/studio/24.png",
    title: "TV Cabinet",
  },
  {
    src: "assets/room/workplace.png",
    title: "Workspace",
  },
  {
    src: "assets/room/kitchen.png",
    title: "Kitchenette",
  },
  {
    src: "assets/room/bedside.png",
    title: "Bedside Kettle",
  },
  {
    src: "assets/room/bathroom.png",
    title: "Bathroom",
  },
  {
    src: "assets/premium/30.png",
    title: "Living Area",
  },
  {
    src: "/assets/41.png",
    title: "Exterior",
  },
];

export default function LifestyleGallery() {
  const width = window.innerWidth;

  const isTablet = width < 1024;
  const isMobile = width < 768;

  return (
    <section
      style={{
        background: "#F5F2EB",
        padding: isMobile ? "80px 20px" : "110px 32px",
      }}
    >
      {/* Heading */}

      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto 60px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".16em",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: isMobile ? 12 : 14,
          }}
        >
          EVERYDAY MOMENTS
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: isMobile ? 34 : isTablet ? 40 : 48,
            color: "#222",
            margin: "18px 0",
            lineHeight: 1.15,
          }}
        >
          More than just a place to stay.
        </h2>

        <p
          style={{
            width: "min(100%, 720px)",
            margin: "0 auto",
            color: "#666",
            lineHeight: 1.8,
            fontSize: isMobile ? 16 : 18,
          }}
        >
          From quiet mornings to productive workdays and relaxing evenings,
          every space is designed to make you feel completely at home.
        </p>
      </div>

      {/* Masonry */}

      <Masonry
        breakpointCols={breakpointColumns}
        className="gallery-grid"
        columnClassName="gallery-column"
      >
        {images.map((image, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              overflow: "hidden",
              marginBottom: isMobile ? 16 : 24,
              cursor: "pointer",
            }}
          >
            <img
              src={image.src}
              alt={image.title}
              loading="lazy"
              style={{
                width: "100%",
                display: "block",
                transition: ".45s",
              }}
            />

            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to top, rgba(0,0,0,.65), transparent 55%)",
                display: "flex",
                alignItems: "flex-end",
                padding: isMobile ? 18 : 24,
              }}
            >
              <h3
                style={{
                  color: "#FFF",
                  fontFamily: "'Fraunces', serif",
                  fontSize: isMobile ? 22 : 28,
                  margin: 0,
                }}
              >
                {image.title}
              </h3>
            </div>
          </div>
        ))}
      </Masonry>
    </section>
  );
}